import { Flex, Button, Box } from 'theme-ui';

import { Svg } from '@snippets';

import { themed } from './Header.theme';

export const Header = themed(
  ({
    theme,
    isOpen,
    iconColor,
    iconOpen = '/svgs/plus.svg',
    iconClosed = '/svgs/minus.svg',
    minHeight,
    index,
    inputRef,
    children,
    ...props
  }) => {
    return (
      <Button
        data-comp={Header.displayName}
        aria-label={`${isOpen ? 'Close' : 'Open'} accordion for ${children}`}
        variant="buttons.plain"
        {...props}
        sx={{
          ...theme.header,
          minHeight,
          lineHeight: minHeight,
          ...props.sx,
        }}
      >
        <Flex sx={theme.flex}>
          <Box sx={theme.text}>{children}</Box>
          <Svg
            src={iconOpen}
            alt="plus"
            viewBox="0 0 16 16"
            loading="lazy"
            sx={{
              ...theme.icon,
              color: iconColor,
              display: isOpen ? 'none' : 'block',
            }}
          />
          <Svg
            src={iconClosed}
            alt="plus"
            viewBox="0 0 16 16"
            loading="lazy"
            sx={{
              ...theme.icon,
              color: iconColor,
              display: isOpen ? 'block' : 'none',
            }}
          />
        </Flex>
      </Button>
    );
  }
);

Header.displayName = 'Header';
